// API Configuration
//export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://botcsignup.onrender.com';
export const API_BASE_URL = 'https://botc.whydecades.com';
//export const API_BASE_URL = 'http://localhost:3001';


// Firebase Configuration
export const FIREBASE_PROJECT_ID = 'botcsignup';
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAhW0GIxuKTS_nVRG2EonR2uRdLEnLZiiY",
  authDomain: "botcsignup.firebaseapp.com",
  projectId: "botcsignup",
  storageBucket: "botcsignup.firebasestorage.app",
  messagingSenderId: "1051233389583",
  appId: "1:1051233389583:web:a36720cc9de1f71effe77a",
  measurementId: "G-5XJ2W333E2"
};

// Environment
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

// Test Environment Control
export const ENABLE_TEST_ENVIRONMENT = process.env.REACT_APP_ENABLE_TEST_ENVIRONMENT === 'true' && IS_DEVELOPMENT;

// Version for cache busting - increment this when deploying to production
export const APP_VERSION = '1.1.8';
export const BUILD_TIMESTAMP = Date.now(); 